<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5">
                <h4 class="text-center text-white">
                    บริษัท สมบูรณ์ แพ็คเกจจิ้ง (888) จำกัด
                </h4>
                <div class="card mt-3">
                    <div class="card-body p-5">
                        <!-- <h3 class="text-center mb-4">เข้าสู่ระบบ</h3> -->
                        <div class="text-center">
                            <img src="../assets/Login_logo.png" class="img-fluid" alt="Responsive image">
                            <img src="../assets/fingerprint.png" class="img-fluid" width="65px" alt="Responsive image">
                        </div>
                        <br/>
                        <div class="text-center">
                            <span style="color: red">กรุณาสแกนนิ้วเพื่อเข้าสู่ระบบ</span>
                        </div>
                        <br/>
                        <div class="form-group text-center">
                            <button type="button" class="btn btn-primary" @click="goToLogin">
                                <icon name="sign-in-alt"></icon>
                                เข้าสู่ระบบด้วย username
                            </button>
                            &nbsp;&nbsp;&nbsp;
                            <button type="button" class="btn btn-warning" disabled >
                                <icon name="fingerprint"></icon>
                                สแกนนิ้ว
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "finger-print-login",
        methods:{
            goToLogin(){
                this.$router.push("/login");
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>